import { Select, Input, Button, Icon } from "semantic-ui-react";
import "./EventNavbar.scss";

export function EventNavbar(props) {
  const {
    filters,
    setFilters,
    setCurrentPage,
    categories,
    viewMode,
    setViewMode,
  } = props;

  const statusOptions = [
    { key: "", value: "", text: "Selecciona un estado" },
    { value: "draft", text: "Borradores" },
    { value: "published", text: "Publicados" },
    { value: "cancelled", text: "Cancelados" },
    { value: "completed", text: "Completados" },
  ];

  const audienceOptions = [
    { key: "", value: "", text: "Selecciona una audiencia" },
    { value: "all", text: "Todos" },
    { value: "students", text: "Estudiantes" },
    { value: "teachers", text: "Docentes" },
    { value: "parents", text: "Padres" },
    { value: "public", text: "Público general" },
  ];

  const sortOptions = [
    { key: "", value: "", text: "Selecciona un orden" },
    { value: "eventDate", text: "Fecha del evento" },
    { value: "createdAt", text: "Más recientes" },
    { value: "title", text: "Título" },
    { value: "viewsCount", text: "Más vistos" },
  ];

  const handleChange = (e, { name, value }) => {
    const newFilters = {
      ...filters,
      [name]: value,
    };
    setFilters(newFilters);
    setCurrentPage(1);
  };

  const handleSearchChange = (e) => {
    const newFilters = {
      ...filters,
      search: e.target.value,
    };
    setFilters(newFilters);
    setCurrentPage(1);
  };

  const clearFilters = () => {
    setFilters({
      status: "",
      categoryId: "",
      targetAudience: "",
      search: "",
      orderBy: "eventDate",
    });
    setCurrentPage(1);
  };

  const hasActiveFilters =
    filters.status ||
    filters.categoryId ||
    filters.targetAudience ||
    filters.search;

  return (
    <div className="admin-event-navbar">
      <div className="admin-event-navbar__filters">
        <div className="admin-event-navbar__filters-left">
          <Button.Group className="view-toggle">
            <Button
              icon
              active={viewMode === "grid"}
              onClick={() => {
                setViewMode("grid");
                localStorage.setItem("eventsViewMode", "grid");
              }}
              title="Vista grid"
            >
              <Icon name="grid layout" />
            </Button>
            <Button
              icon
              active={viewMode === "list"}
              onClick={() => {
                setViewMode("list");
                localStorage.setItem("eventsViewMode", "list");
              }}
              title="Vista lista"
            >
              <Icon name="list" />
            </Button>
          </Button.Group>

          <div className="admin-event-navbar__search">
            <Input
              icon="search"
              placeholder="Buscar eventos..."
              value={filters.search || ""}
              onChange={handleSearchChange}
              className="search-input"
            />
          </div>
          <Select
            name="status"
            className="admin-event-navbar__filter-select edunova-select"
            placeholder="Selecciona un estado"
            options={statusOptions}
            value={filters.status}
            onChange={handleChange}
            clearable
          />
          <Select
            name="categoryId"
            className="admin-event-navbar__filter-select edunova-select"
            placeholder="Selecciona una categoría"
            options={[{ key: "", value: "", text: "Selecciona una categoría" }, ...(categories || [])]}
            value={filters.categoryId}
            onChange={handleChange}
            clearable
          />
          <Select
            name="targetAudience"
            className="admin-event-navbar__filter-select edunova-select"
            placeholder="Selecciona una audiencia"
            options={audienceOptions}
            value={filters.targetAudience}
            onChange={handleChange}
            clearable
          />
          <Select
            name="orderBy"
            className="admin-event-navbar__filter-select edunova-select"
            placeholder="Selecciona un orden"
            options={sortOptions}
            value={filters.orderBy}
            onChange={handleChange}
            clearable
          />
            <Button color="grey" onClick={clearFilters}>
              <Icon name="eraser" />
              Limpiar filtros
            </Button>
        </div>
      </div>
    </div>
  );
}
